import { Typography } from '@mui/material';
import React from 'react';

const AudiencePage: React.FC = () => {
    return (
        <div>
            <Typography variant="h5" component="h2" className='page-title'>Audience</Typography>
            <p>This is the audience page</p>
        </div>
    );
};

export default AudiencePage;